export default "__VITE_ASSET__DilujHyo__"